import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'themeOverrides',
  initialState: null as null | ThemeOverrides,
  reducers: {
    setThemeOverrides(state, action: PayloadAction<ThemeOverrides>) {
      return action.payload || null;
    },
  },
});

export const { setThemeOverrides } = slice.actions;

export default slice.reducer;
